import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import HomePage from './pages/HomePage/HomePage';
import AppLume from './pages/AppLume/AppLume';
import TermsPage from './pages/TermsPage/TermsPage';

function App() {
  return (
    <Router>
      <Routes>
        <Route path="/" element={<HomePage />} />
        <Route path="/lume" element={<AppLume />} />
        <Route path="/lume/terms/:type" element={<TermsPage />} />
      </Routes>
    </Router>
  );
}

export default App;
